import { render } from "./MusMatEntryDetailed.vue?vue&type=template&id=f6202cd6&scoped=true"
import script from "./MusMatEntryDetailed.vue?vue&type=script&lang=js"
export * from "./MusMatEntryDetailed.vue?vue&type=script&lang=js"

import "./MusMatEntryDetailed.vue?vue&type=style&index=0&id=f6202cd6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6202cd6"]])

export default __exports__